import type { FunctionComponent, ReactNode } from "react";

import { i18nFilter } from "app/filters/i18nFilter";
import { bigNumberFilter, minAbbrNumberFilter } from "app/filters/ngFilters";
import { NoDataLandscape } from "pro-features/components/NoData/src/NoData";
import {
    ContentWrapper,
    ShareNumber,
    StyledBox,
    TitleContainer,
    TopPart,
    TotalVisitsBottonWrapper,
    TotalVisitsWrapper,
} from "./StyledComponents";
import { WidgetTitle } from "app/components/widget-title/WidgetTitle";
import { WidgetLoader } from "app/components/widget-loader/WidgetLoader";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export interface ISourceItem {
    Name: string;
    Count: number;
    Value: number;
}

export interface ISocialTotalVisitsData {
    dictionary: Record<
        string,
        { Dates: string[]; SearchTotal: number; VolumeTotal: number; Volumes: Array<Array<string>> }
    >;
    Sources: Array<ISourceItem>;
}

interface ITotalVisitsProps {
    type: string;
    share?: number;
    loading?: boolean;
    data?: ISocialTotalVisitsData;
    a2d?: () => ReactNode;
    height?: string;
    subTitleFilters: any;
    shareText: string;
    numberFormat?: (val) => string;
}

const i18n = i18nFilter();
const bigNumber = bigNumberFilter();

export const SocialTotalVisits: FunctionComponent<ITotalVisitsProps> = ({
    type,
    share,
    loading,
    data,
    a2d,
    height,
    subTitleFilters,
    shareText,
    numberFormat,
}) => {
    const { key } = proNavigator.getParams();
    const title = i18n(`${type}.totalvisits.title`);
    const tooltip = i18n("social.totalvisits.title.tooltip", { param: type });

    const getNumberFilter = (value) => {
        return numberFormat ? numberFormat(value) : minAbbrNumberFilter()(bigNumber(value));
    };
    const getComponent = () => {
        const noData = !data || !data.dictionary[key].SearchTotal;
        return (
            <>
                {!noData ? (
                    <ContentWrapper>
                            <TopPart>
                                <TotalVisitsWrapper>
                                    {getNumberFilter(data.dictionary[key].SearchTotal)}
                                </TotalVisitsWrapper>

                                {share > 0 && (
                                    <TotalVisitsBottonWrapper>
                                        <ShareNumber>{(share * 100).toFixed(2)}% </ShareNumber>
                                        {i18n(shareText)}
                                    </TotalVisitsBottonWrapper>
                                )}
                            </TopPart>
                        </ContentWrapper>
                ) : (
                    <NoDataLandscape
                        title="global.nodata.notavilable"
                        subtitle={null}
                    />
                )}
            </>
        );
    };

    return (
        <StyledBox
            width="100%"
            height={height}
            marginRight={24}
        >
            <TitleContainer>
                <WidgetTitle
                    title={title}
                    tooltip={tooltip}
                    filters={subTitleFilters}
                    addToDashboard={a2d}
                />
            </TitleContainer>
            {loading ? <WidgetLoader /> : getComponent()}
        </StyledBox>
    );
};
